var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechAdvancments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 148,
    viewBox: "0 0 109 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 137.542L17.4782 127.459L34.9433 137.542L17.4782 147.638L0 137.542Z",
    fill: "#173D7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0938 115.855L54.5589 105.759L72.024 115.855L54.5589 125.939L37.0938 115.855Z",
    fill: "#173D7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0562 94.6666L91.5344 84.5835L109 94.6666L91.5344 104.763L74.0562 94.6666Z",
    fill: "#173D7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5594 115.856V62.0572L37.0942 51.9741V105.759L54.5594 115.856Z",
    fill: "#C13D1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5596 62.0572L72.0247 51.9741V105.759L54.5596 115.856V62.0572Z",
    fill: "#D3008D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5594 115.856V62.0572L37.0942 51.9741V105.759L54.5594 115.856Z",
    fill: "#D3008D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4782 137.541V107.292L0 97.1958V127.458L17.4782 137.541Z",
    fill: "#D3008D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.479 107.292L34.9441 97.1958V127.458L17.479 137.541V107.292Z",
    fill: "#D3008D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 97.1969L17.4782 87.1138L34.9433 97.1969L17.4782 107.293L0 97.1969Z",
    fill: "#FF2C9C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5344 94.6663V20.7017L74.0562 10.6187V84.5832L91.5344 94.6663Z",
    fill: "#D3008D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5347 20.7017L109 10.6187V84.5832L91.5347 94.6663V20.7017Z",
    fill: "#D3008D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0562 10.6183L91.5344 0.535156L109 10.6183L91.5344 20.7013L74.0562 10.6183Z",
    fill: "#FF2C9C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0942 51.9737L54.5594 41.8774L72.0245 51.9737L54.5594 62.0568L37.0942 51.9737Z",
    fill: "#FF2C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechAdvancments);
export default __webpack_public_path__ + "static/media/tech-advancments.4efbcd31772fb8f64ee4f4795279df35.svg";
export { ForwardRef as ReactComponent };